if (!customElements.get("collection-search-bar")) {
  class CollectionSearchBar extends HTMLElement {
    constructor() {
      super();
      this._onFillChange = this._onFillChange.bind(this);
      this._onFocusIn = this._onFocusIn.bind(this);
      this._onFocusOut = this._onFocusOut.bind(this);
      this._onClearClick = this._onClearClick.bind(this);
      this._doSearch = this._debounce(this._doSearch.bind(this), 250);
    }

    connectedCallback() {
      this.searchBarElement = this.querySelector(".search-bar");
      this.inputElement = this.querySelector('[name="q"]');
      this.searchResultsElement = this.querySelector(".search-bar__results");
      this.lastInputValue = "";
      this._supportsPredictiveApi = JSON.parse(
        document.getElementById("shopify-features").innerHTML,
      )["predictiveSearch"];

      this._attachListeners();
    }

    _attachListeners() {
      this.inputElement.addEventListener("input", this._onFillChange);
      this.inputElement.addEventListener("input", this._doSearch);
      this.inputElement.addEventListener("focusin", this._onFocusIn);
      document.addEventListener("click", this._onFocusOut);

      const clearButton = this.querySelector('[data-action="clear-input"]');
      if (clearButton) {
        clearButton.addEventListener("click", this._onClearClick);
      }
    }

    disconnectedCallback() {
      this.inputElement.removeEventListener("input", this._onFillChange);
      this.inputElement.removeEventListener("input", this._doSearch);
      this.inputElement.removeEventListener("focusin", this._onFocusIn);
      document.removeEventListener("click", this._onFocusOut);

      const clearButton = this.querySelector('[data-action="clear-input"]');
      if (clearButton) {
        clearButton.removeEventListener("click", this._onClearClick);
      }
    }

    _onFillChange() {
      this.inputElement.classList.toggle("is-filled", this.inputElement.value !== "");
    }

    _onClearClick() {
      this.inputElement.value = "";
      this.inputElement.dispatchEvent(new Event("input"));
      this.inputElement.focus();
    }

    _onFocusIn() {
      if (this.inputElement.value !== "") {
        this.searchResultsElement.setAttribute("aria-hidden", "false");
        this.searchBarElement.classList.add("is-expanded");
      }
    }

    _onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) {
          this.searchResultsElement.setAttribute("aria-hidden", "true");
          this.searchBarElement.classList.remove("is-expanded");
        }
      }, 150);
    }

    _doSearch() {
      const currentInput = this.inputElement.value;
      this.lastInputValue = currentInput;

      if (currentInput === "") {
        this.searchResultsElement.setAttribute("aria-hidden", "true");
        this.searchBarElement.classList.remove("is-expanded");
        return;
      }

      this.searchResultsElement.setAttribute("aria-hidden", "false");
      this.searchBarElement.classList.add("is-expanded", "is-loading");

      const collectionFilter = this.dataset.collectionHandle
        ? `tag:"collection:${this.dataset.collectionHandle}" AND `
        : "";
      const url = `${window.Shopify.routes.root}search${this._supportsPredictiveApi ? "/suggest" : ""}`;
      fetch(
        `${url}?section_id=collection-search-panel&q=${collectionFilter}${encodeURIComponent(currentInput)}&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor`,
        { method: "GET", credentials: "same-origin" },
      )
        .then((r) => r.text())
        .then((html) => {
          if (this.lastInputValue !== currentInput) return;
          this.searchBarElement.classList.remove("is-loading");
          const div = document.createElement("div");
          div.innerHTML = html;
          const ajax = div.querySelector(".search-ajax");
          this.searchBarElement.querySelector(
            ".search-bar__results-inner",
          ).innerHTML = ajax ? ajax.innerHTML : "";
        })
        .catch(() => {
          this.searchBarElement.classList.remove("is-loading");
        });
    }

    _debounce(fn, delay) {
      let timer;
      return () => {
        clearTimeout(timer);
        timer = setTimeout(fn, delay);
      };
    }
  }

  customElements.define("collection-search-bar", CollectionSearchBar);
}
